import { useTranslation } from 'react-i18next';
import { NetWorthCard } from '../net-worth-card.jsx';
import { WealthCard } from '../wealth-card.jsx';
import { PortfolioCard } from '../portfolio-card.jsx';

/**
 * Reports use-case mockup: net worth, wealth breakdown, and portfolio cards
 * stacked and slightly overlapped so the edges fade into the page.
 * @returns {JSX.Element}
 */
export function ReportsScreen() {
	const { t } = useTranslation();
	return (
		<>
			<div className="report-stack">
				<div className="report-stack-card report-stack-networth">
					<NetWorthCard />
				</div>
				<div className="report-stack-card report-stack-wealth">
					<WealthCard />
				</div>
				<div className="report-stack-card report-stack-portfolio">
					<PortfolioCard />
				</div>
			</div>
			<div className="use-case-callout card">
				<h3>{t('usecase.reports.cards.title')}</h3>
				<p>{t('usecase.reports.lede')}</p>
			</div>
		</>
	);
}
